<template>
  <component :is="route.meta.layout ?? NoHeader">
    <RouterView
      v-slot="{ Component }"
      :key="`${route.params.jobId}-${locale}`"
    >
      <PageTransition transition="fade">
        <div>
          <Spinner
            v-if="appStateStore.loading || loadingLocale"
            fullscreen
          />
          <component
            :is="Component"
            v-else
          />
        </div>
      </PageTransition>
    </RouterView>
  </component>
  <div id="modal-target"></div>
</template>
<script setup lang="ts">
import { localeMessageLoaders } from '@/i18n';
import { useAppStore } from '@/store/appState';
import PageTransition from '@shared/components/PageTransition.vue';
import Spinner from '@shared/components/Spinner.vue';
import { useUserLocale } from '@shared/composables/useUserLocale';
import { RouterView, useRoute } from 'vue-router';

import NoHeader from './layouts/NoHeader.vue';

const appStateStore = useAppStore();
const route = useRoute();
// Pages re-mount on a locale change so strings resolved once at setup pick up the new language
const { locale, loadingLocale } = useUserLocale(localeMessageLoaders);
</script>

<style lang="scss">
@import '@/assets/scss/_app.scss';
</style>
